import React, { Component, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { Tooltip } from "@material-ui/core";
import moment from "moment";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter, // ✅ NEW
  Input, // ✅ NEW
  Button,
  Form,
} from "reactstrap";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Formik, Field, ErrorMessage } from "formik";
import debounce from "lodash/debounce";
import "assets/scss/table.scss";

//Import Breadcrumb
import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  getAnalytesData,
  postResult,
  // getResultsList,
  updateResult,
} from "store/results/actions";
// import { getunitlist } from "store/units/actions";
// import { getmethodlist } from "store/methods/actions";
// import { getInstrumentlist } from "store/instrument/actions";
// import { getReagentlist } from "store/reagents/actions";
import * as XLSX from "xlsx";

import "assets/scss/table.scss";
import { round } from "lodash";

class Results extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      ReagentList: [],
      schemeType: "", // start empty, will be updated later
      schemeName: "", // start empty
      Instrument: [],
      ListMethods: [],
      ListUnits: [],
      AnalyteData: [],
      combinedData: [],
      //  analytes: [],   // <-- add this
      submittedResults: [],
      loading: true, // ✅ new flag
      list: "",
      unit_name: "",
      instrument_name: "",
      method_name: "",
      reagent_name: "",
      result_type: "",
      result: "",
      schemeName: "",
      schemeType: "",
      round_status: "",
      result_status: "Created",
      rounds: "",
      issue_date: "",
      closing_date: "",
      // participantID: "",
      // participant_ids: [],
      PostResult: [],
      ResultList: [],
      isDataLoaded: false, // Flag to track if all data is loaded
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      submittedOn: localStorage.getItem("submittedOn") || null,
      sample_condition: "", // ✅ holds the participant's recorded sample condition
      rating: null, // ✅ NEW — holds the participant's recorded rating for that condition
      conditionRatings: {}, // ✅ NEW — remembers a rating per-condition while switching the dropdown

      // ✅ NEW — Abrogate mode state
      abrogateModal: false,
      abrogateRow: null,
      abrogateReason: "",
      abrogateError: "",
      abrogating: false,
    };
    this.handleUpdate = this.handleUpdate.bind(this);
    this.validateResult = this.validateResult.bind(this);
  }

  // ✅ NEW — same bar-status helper used on the submission page
  getBarStatus = rating => {
    if (!rating) return null;
    if (rating === 1 || rating === 2) return "Low";
    if (rating === 3) return "Medium";
    if (rating >= 4) return "High";
    return null;
  };

  // ✅ NEW — true when page is opened with ?mode=abrogate
  isAbrogateMode = () =>
    new URLSearchParams(this.props.location.search).get("mode") === "abrogate";

  // ✅ NEW — open the abrogate / restore modal for one analyte row
  openAbrogateModal = row =>
    this.setState({
      abrogateModal: true,
      abrogateRow: row,
      abrogateReason: "",
      abrogateError: "",
    });

  closeAbrogateModal = () =>
    this.setState({ abrogateModal: false, abrogateRow: null });

  // ✅ NEW — abrogate or restore a single analyte result
  submitAbrogate = async () => {
    const { abrogateRow, abrogateReason, participantID, user_id } = this.state;
    const roundId = this.props.match.params.id;
    const isRestore = !!abrogateRow?.abrogated;

    if (!isRestore && !abrogateReason.trim()) {
      this.setState({ abrogateError: "Reason is required." });
      return;
    }

    // Same existing update endpoint, but only the identifying keys plus the
    // abrogation fields are sent. The backend then touches ONLY those fields
    // on the saved result, so unit/instrument/method/reagent can't be wiped.
    const payload = {
      round_id: roundId,
      analyte_id: abrogateRow.analyte_id,
      rounds: this.props.rounds,
      scheme_id: this.props.scheme_id,
      abrogated: !isRestore,
      abrogation_reason: isRestore ? "" : abrogateReason.trim(),
      abrogated_by: user_id,
    };

    try {
      this.setState({ abrogating: true, abrogateError: "" });

      // Same action Submit uses (onUpdateResult -> saga -> update API).
      // A callback is passed too, but we don't depend on it: after a short
      // wait we re-read the saved result and verify the change really landed.
      await new Promise(resolve => {
        let done = false;
        const finish = r => {
          if (!done) {
            done = true;
            resolve(r);
          }
        };
        this.props.onUpdateResult(payload, participantID, finish);
        setTimeout(() => finish(null), 2000);
      });

      const fresh = await this.fetchSubmittedResults();
      const saved = (fresh || []).find(
        r => String(r.analyte) === String(abrogateRow.analyte_id)
      );

      if (saved && !!saved.abrogated === !isRestore) {
        this.setState({ abrogateModal: false, abrogateRow: null });
      } else {
        this.setState({
          abrogateError:
            "The change was not saved. Check the update request in the browser Network tab.",
        });
      }
    } catch (e) {
      console.error("Abrogate failed:", e);
      this.setState({
        abrogateError:
          e?.response?.data?.message ||
          e?.message ||
          "Failed to update abrogation.",
      });
    } finally {
      this.setState({ abrogating: false });
    }
  };

  // ✅ NEW — read-only columns shown in abrogate mode
  getAbrogateColumns = () => {
    const { schemeType } = this.props;

    // ✅ Abrogate column is defined here but added as the LAST column below
    const abrogateColumn = {
      text: "Abrogate",
      dataField: "abrogate_action",
      isDummyField: true,
      headerStyle: { width: "120px" },
      formatter: (cell, row) =>
        !row.result_id ? (
          <span className="text-muted small">No result</span>
        ) : row.abrogated ? (
          <Button
            size="sm"
            color="success"
            onClick={() => this.openAbrogateModal(row)}
          >
            <i className="fas fa-undo me-1" /> Restore
          </Button>
        ) : (
          <Button
            size="sm"
            color="danger"
            onClick={() => this.openAbrogateModal(row)}
          >
            <i className="fas fa-ban me-1" /> Abrogate
          </Button>
        ),
    };

    const cols = [{ text: "Analyte", dataField: "analyte_name", sort: true }];

    if (schemeType === "Quantitative") {
      cols.push({ text: "Unit", dataField: "unit_name" });
    }
    cols.push(
      { text: "Instrument", dataField: "instrument_name" },
      { text: "Method", dataField: "method_name" },
      { text: "Reagent", dataField: "reagent_name" }
    );
    if (schemeType === "Qualitative") {
      cols.push({ text: "Result Type", dataField: "result_type" });
    }
    cols.push(
      {
        text: "Result Value",
        dataField: "result",
        formatter: (cell, row) => (
          <span style={row.abrogated ? { textDecoration: "line-through" } : {}}>
            {cell}
          </span>
        ),
      },
      {
        text: "Status",
        dataField: "abrogated",
        formatter: (cell, row) =>
          row.abrogated ? (
            <span className="badge bg-danger" title={row.abrogation_reason}>
              Abrogated
            </span>
          ) : row.result_id ? (
            <span className="badge bg-success">Active</span>
          ) : null,
      }
    );
    cols.push(abrogateColumn); // ✅ last column
    return cols;
  };

  getApprovedLabListColumns = () => {
    // ✅ NEW — abrogate mode uses its own read-only columns
    if (this.isAbrogateMode()) return this.getAbrogateColumns();

    const { schemeType } = this.props;

    if (schemeType === "Quantitative") {
      return [
        {
          text: "Analyte",
          dataField: "analyte_name",
          headerStyle: {
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: {
            backgroundColor: "#a6d4ff", // Grayish for cells
          },
          sort: true,
        },
        {
          text: "Unit",
          dataField: "unit_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.unit_id || ""}
              onChange={e => this.handleUnitChange(e, row)}
            >
              <option value="">Select Unit</option>
              {(row.availableUnits || []).map(unit => (
                <option
                  key={`${row.analyte_id}_unit_${unit.id}`}
                  value={unit.id}
                >
                  {unit.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Instrument",
          dataField: "instrument_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.instrument_id || ""}
              onChange={e => this.handleInstrumentChange(e, row)}
            >
              <option value="">Select Instrument</option>
              {(row.availableInstruments || []).map(instr => (
                <option
                  key={`${row.analyte_id}_instr_${instr.id}`}
                  value={instr.id}
                >
                  {instr.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Method",
          dataField: "method_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.method_id || ""}
              onChange={e => this.handleMethodChange(e, row)}
            >
              <option value="">Select Method</option>
              {(row.availableMethods || []).map(method => (
                <option
                  key={`${row.analyte_id}_method_${method.id}`}
                  value={method.id}
                >
                  {method.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Reagent",
          dataField: "reagent_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.reagent_id || ""}
              onChange={e => this.handleReagentChange(e, row)}
            >
              <option value="">Select Reagent</option>
              <option value="">Select Reagent</option>
              {(row.availableReagents || []).map((reagent, idx) => (
                <option
                  key={`${row.analyte_id}_reagent_${reagent.id}_${idx}`}
                  value={reagent.id}
                >
                  {reagent.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Result Value",
          dataField: "result",
          formatter: (cell, row) => (
            <input
              type="text"
              className="form-control"
              ref={el => (this[`resultRef_${row.analyte_id}`] = el)}
              defaultValue={row.result || ""}
              placeholder="Enter result"
              onBlur={e => {
                const value = e.target.value.trim();
                const updatedData = this.state.combinedData.map(item =>
                  item.analyte_id === row.analyte_id
                    ? { ...item, result: value }
                    : item
                );
                this.setState({ combinedData: updatedData });
              }}
            />
          ),
        },
      ];
    }

    if (schemeType === "Qualitative") {
      return [
        {
          text: "Analyte",
          dataField: "analyte_name",
          sort: true,
        },
        {
          text: "Instrument",
          dataField: "instrument_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.instrument_id || ""}
              onChange={e => this.handleInstrumentChange(e, row)}
            >
              <option value="">Select Instrument</option>
              {(row.availableInstruments || []).map(instr => (
                <option
                  key={`${row.analyte_id}_instr_${instr.id}`}
                  value={instr.id}
                >
                  {instr.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Method",
          dataField: "method_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.method_id || ""}
              onChange={e => this.handleMethodChange(e, row)}
            >
              <option value="">Select Method</option>
              {[
                ...new Map(
                  (row.availableMethods || []).map(m => [m.id, m])
                ).values(),
              ].map(method => (
                <option
                  key={`${row.analyte_id}_method_${method.id}`}
                  value={method.id}
                >
                  {method.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Reagent",
          dataField: "reagent_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.reagent_id || ""}
              onChange={e => this.handleReagentChange(e, row)}
            >
              <option value="">Select Reagent</option>
              {(row.availableReagents || []).map((reagent, idx) => (
                <option
                  key={`${row.analyte_id}_reagent_${reagent.id}_${idx}`}
                  value={reagent.id}
                >
                  {reagent.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Result Type",
          dataField: "result_type",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.result_type || ""}
              onChange={e => this.handleResultTypeChange(e, row)}
            >
              <option value="">Select Result Type</option>
              {["Positive", "Negative", "Equivocal"].map(type => (
                <option key={`${row.analyte_id}_type_${type}`} value={type}>
                  {type}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Result Value",
          dataField: "result",
          formatter: (cell, row) => (
            <input
              type="text"
              className="form-control"
              ref={el => (this[`resultRef_${row.analyte_id}`] = el)}
              defaultValue={row.result || ""}
              placeholder="Enter result"
              onBlur={e => {
                const value = e.target.value.trim();
                const updatedData = this.state.combinedData.map(item =>
                  item.analyte_id === row.analyte_id
                    ? { ...item, result: value }
                    : item
                );
                this.setState({ combinedData: updatedData });
              }}
            />
          ),
        },
      ];
    }

    return [];
  };

  hydrateAnalytes = () => {
    const { AnalyteData, units, methods, reagents, instruments } = this.props;

    if (!Array.isArray(AnalyteData)) return [];

    return AnalyteData.map(analyte => {
      return {
        ...analyte,
        availableUnits: (units || []).filter(u =>
          (analyte.units || []).includes(u.id)
        ),
        availableMethods: (methods || []).filter(m =>
          (analyte.methods || []).includes(m.id)
        ),
        availableReagents: (reagents || []).filter(r =>
          (analyte.reagents || []).includes(r.id)
        ),
        availableInstruments: (instruments || []).filter(i =>
          (i.analytes || []).includes(analyte.id)
        ),
      };
    });
  };

  componentDidMount() {
    this._isMounted = true; // ✅ mark as mounted

    const { onGetAnalytedata } = this.props;
    const roundId = this.props.match.params.id;

    const searchParams = new URLSearchParams(this.props.location.search);
    const participantIDFromQuery = searchParams.get("participantID");

    const userAuth = localStorage.getItem("authUser");
    const userId = userAuth ? JSON.parse(userAuth).user_id : null;
    const participantID = participantIDFromQuery || userId;

    console.log(
      "componentDidMount — roundId:",
      roundId,
      "participantID:",
      participantID
    );

    if (participantID) {
      this.setState({ participantID }, () => {
        if (roundId) {
          onGetAnalytedata(roundId);
          // onGetResultsList(roundId);
          this.fetchSubmittedResults(); // 🔹 safe, but will check mounted later
        }
      });
    }

    const submittedOn = localStorage.getItem("submittedOn");
    if (submittedOn) {
      this.setState({ submittedOn });
    }
  }

  componentWillUnmount() {
    this._isMounted = false; // ✅ mark as unmounted
  }

  componentDidUpdate(prevProps, prevState) {
    const { AnalyteData } = this.props;
    const { submittedResults } = this.state;

    const analytesLoaded =
      AnalyteData.length > 0 && AnalyteData !== prevProps.AnalyteData;
    const resultsLoaded =
      submittedResults.length > 0 &&
      submittedResults !== prevState.submittedResults;

    // ✅ Only combine when *both* are available
    if (
      (analytesLoaded || resultsLoaded) &&
      AnalyteData.length &&
      submittedResults.length
    ) {
      console.log("🔄 Re-checking combineData (props/state changed)");
      this.combineData();
    }
  }

  fetchSubmittedResults = async () => {
    const roundId = this.props.match.params.id;
    const { participantID } = this.state;

    if (!roundId || !participantID) {
      return;
    }

    try {
      this.setState({ loading: true });

      const res = await axios.get(
        `https://externalqcapi.com/api/registration-admin/getResultsData/${roundId}?lab_id=${participantID}`
      );

      const allResults = res?.data?.data || [];
      const filtered = allResults.filter(
        result => result.lab && result.lab.id === parseInt(participantID)
      );

      if (this._isMounted) {
        const labName = filtered.length > 0 ? filtered[0].lab?.name : "";

        this.setState(
          {
            submittedResults: filtered,
            labName,
            loading: false,
          },
          () => {
            this.combineData();
          }
        );
      }
      return filtered;
    } catch (error) {
      console.error("🚨 Error fetching submitted results:", error);
      if (this._isMounted) this.setState({ loading: false });
      return [];
    }
  };

  //
  sortOptions = (options, key = "name") => {
    if (!options) return [];
    return [...options].sort((a, b) =>
      String(a[key]).localeCompare(String(b[key]))
    );
  };

  combineData = () => {
    console.log("🛠 combineData() called");

    const { submittedResults } = this.state;
    const { AnalyteData, units, methods, reagents, instruments } = this.props;

    if (!AnalyteData?.length || !submittedResults?.length) {
      console.log("⏸ Waiting for analytes and results to load...", {
        analytes: AnalyteData?.length,
        results: submittedResults?.length,
      });
      return;
    }

    const combinedData = AnalyteData.map(analyte => {
      const userResult = (submittedResults || []).find(
        r => String(r.analyte) === String(analyte.id)
      );

      return {
        analyte_id: analyte.id,
        analyte_name: analyte.name,
        result: userResult?.result || "",
        result_type: userResult?.result_type || "",
        // ✅ NEW — result id + abrogation status (used in abrogate mode)
        result_id: userResult?.id || null,
        abrogated: !!userResult?.abrogated,
        abrogation_reason: userResult?.abrogation_reason || "",
        result_status: userResult?.result_status || "",
        // ✅ carry the participant's recorded sample condition & rating per row
        sample_condition: userResult?.sample_condition || "",
        rating: userResult?.rating || null, // ✅ NEW
        // ✅ IDs first, fallback: map names → IDs
        unit_id:
          userResult?.unit_id ||
          (units.find(u => u.name === userResult?.unit_name)?.id ?? null),
        unit_name: userResult?.unit_name || "",

        method_id:
          userResult?.method_id ||
          (methods.find(m => m.name === userResult?.method_name)?.id ?? null),
        method_name: userResult?.method_name || "",

        instrument_id:
          userResult?.instrument_id ||
          (instruments.find(i => i.name === userResult?.instrument_name)?.id ??
            null),
        instrument_name: userResult?.instrument_name || "",

        reagent_id:
          userResult?.reagent_id ||
          (reagents.find(r => r.name === userResult?.reagent_name)?.id ?? null),
        reagent_name: userResult?.reagent_name || "",

        // 🔹 Options per analyte
        availableUnits: (units || []).filter(u => analyte.units.includes(u.id)),
        availableMethods: (methods || []).filter(m =>
          analyte.methods.includes(m.id)
        ),
        availableInstruments: (instruments || []).filter(i =>
          (i.analytes || []).includes(analyte.id)
        ),
        availableReagents: (reagents || []).filter(rg =>
          analyte.reagents.includes(rg.id)
        ),
      };
    });

    // ✅ pull the participant-level sample condition + rating (same value
    // across rows in practice, recorded once per submission) so the
    // dropdown/rating bars can be pre-filled with what's already saved.
    const savedSampleCondition =
      combinedData.find(d => d.sample_condition)?.sample_condition || "";
    const savedRating = combinedData.find(d => d.rating)?.rating || null; // ✅ NEW

    console.log("📋 Final combinedData:", combinedData);
    this.setState({
      combinedData,
      loading: false,
      sample_condition: savedSampleCondition,
      rating: savedRating, // ✅ NEW
      conditionRatings: savedSampleCondition // ✅ NEW
        ? { [savedSampleCondition]: savedRating }
        : {},
    });
  };

  constructResultData = (list, resultValue, resultStatus) => {
    const { rounds, scheme_id, round_status } = this.props;
    const round_id = this.props.match.params.id;

    return {
      round_id,
      analyte_id: list.analyte_id,
      rounds,
      scheme_id,
      round_status: round_status || "Closed",
      result_status: resultStatus,
      result_type: list.result_type || null,
      result: resultValue,

      // ✅ Use IDs, not names
      units: list.units || null,
      instrument: list.instrument || null,
      method: list.method || null,
      reagents: list.reagents || null,
    };
  };
  // Helper method: Validates result
  validateResult = resultValue => {
    if (!resultValue) {
      alert("Result is required before submitting.");
      return false;
    }
    return true;
  };

  // Update a single analyte
  handleUpdate = async list => {
    const { participantID } = this.state;
    const resultValue =
      this[`resultRef_${list.analyte_id}`]?.value?.trim() || null;

    if (!this.validateResult(resultValue)) return;

    const resultData = {
      round_id: this.props.match.params.id,
      analyte_id: list.analyte_id,
      result: resultValue,
      result_type: list.result_type || "Not Submitted",
      result_status: "Created",
      rounds: this.props.rounds,
      round_status: this.props.round_status || "Closed",
      scheme_id: this.props.scheme_id,
      units: list.unit_id || null,
      instrument_id: list.instrument_id || null,
      method_id: list.method_id || null,
      reagent_id: list.reagent_id || null,
      sample_condition: this.state.sample_condition || "",
      rating: this.state.rating || null,
      bar_status: this.getBarStatus(this.state.rating) || "",
    };

    // ✅ Use a callback instead of await
    this.props.onUpdateResult(
      resultData,
      list.lab_id || participantID,
      async response => {
        if (response?.status === 200 || response?.status === "200") {
          alert(response.message || "Result updated successfully.");
          await this.fetchSubmittedResults();
          this.combineData();
        } else {
          alert(response?.message || "Failed to update result.");
        }
      }
    );
  };

  handleSubmit = async () => {
    const { combinedData, comments, participantID, sample_condition, rating } =
      this.state;
    const { rounds, scheme_id, round_status } = this.props;
    const round_id = this.props.match.params.id;

    if (!combinedData.length) {
      alert("⚠️ No results to submit.");
      return;
    }

    const confirmation = window.confirm(
      "Are you sure you want to submit all results?"
    );
    if (!confirmation) return;

    let hasAtLeastOne = false;
    let errors = [];

    // ✅ shared payload builder so the "sample condition only" fallback
    // below stays in sync with the normal per-analyte payload
    const buildPayload = (row, resultValue) => ({
      round_id,
      analyte_id: row.analyte_id,
      units: row.unit_id || null,
      instrument_id: row.instrument_id || null,
      method_id: row.method_id || null,
      reagent_id: row.reagent_id || null,
      result: resultValue,
      rounds,
      round_status: round_status || "Closed",
      scheme_id,
      result_status: "Submitted",
      result_type: row.result_type || "Not Submitted",
      comment: comments || "",
      sample_condition: sample_condition || "",
      rating: rating || null,
      bar_status: this.getBarStatus(rating) || "",
    });

    for (const row of combinedData) {
      const resultValue =
        this[`resultRef_${row.analyte_id}`]?.value?.trim() || row.result || "";

      // ✅ Case 1: result is provided → all other fields mandatory
      if (resultValue) {
        if (!row.instrument_id || !row.method_id || !row.reagent_id) {
          errors.push(
            `❌ Missing Instrument/Method/Reagent for analyte: ${row.analyte_name}`
          );
          continue; // ⏭ skip this analyte but keep submitting others
        }
      }

      // ✅ Case 2: result is missing → skip only if nothing else is selected
      if (
        !resultValue &&
        !row.instrument_id &&
        !row.method_id &&
        !row.reagent_id
      ) {
        console.warn(
          `⏭ Skipping analyte ${row.analyte_name} — no result AND no instrument/method/reagent`
        );
        continue;
      }

      const payload = buildPayload(row, resultValue);

      try {
        console.log("🚀 Submitting analyte:", row.analyte_id, payload);
        await this.props.onUpdateResult(payload, participantID); // sequential submit
        hasAtLeastOne = true;
      } catch (err) {
        console.error("❌ Failed to submit analyte:", row.analyte_id, err);
        errors.push(`❌ Failed to submit analyte: ${row.analyte_name}`);
      }
    }

    // ✅ NEW — every row was empty/skipped, but a sample condition was recorded.
    // Send it on its own (result left blank) so it isn't silently lost.
    if (!hasAtLeastOne && sample_condition) {
      const carrierRow = combinedData[0];
      const payload = buildPayload(carrierRow, "");

      try {
        console.log("🚀 Submitting sample condition only:", payload);
        await this.props.onUpdateResult(payload, participantID);
        hasAtLeastOne = true;
      } catch (err) {
        console.error("❌ Failed to submit sample condition:", err);
        errors.push("❌ Failed to submit sample condition.");
      }
    }

    if (hasAtLeastOne) {
      alert("✅ Results submitted successfully!");
      await this.fetchSubmittedResults();
      this.combineData();
    } else {
      alert("⚠️ No valid results were submitted.");
    }

    if (errors.length) {
      alert(errors.join("\n"));
    }
  };

  handleUnitChange = (event, row) => {
    const selectedId = parseInt(event.target.value);
    const selectedUnit = (this.props.units || []).find(
      u => u.id === selectedId
    );

    const updatedData = this.state.combinedData.map(item =>
      item.analyte_id === row.analyte_id
        ? { ...item, unit_id: selectedId, unit_name: selectedUnit?.name || "" }
        : item
    );

    this.setState({ combinedData: updatedData });
  };

  handleMethodChange = (event, row) => {
    const selectedId = parseInt(event.target.value);
    const selectedMethod = (this.props.methods || []).find(
      m => m.id === selectedId
    );

    const updatedData = this.state.combinedData.map(item =>
      item.analyte_id === row.analyte_id
        ? {
            ...item,
            method_id: selectedId,
            method_name: selectedMethod?.name || "",
          }
        : item
    );

    this.setState({ combinedData: updatedData });
  };

  handleInstrumentChange = (event, row) => {
    const selectedId = parseInt(event.target.value);
    const selectedInstrument = (this.props.instruments || []).find(
      i => i.id === selectedId
    );

    const updatedData = this.state.combinedData.map(item =>
      item.analyte_id === row.analyte_id
        ? {
            ...item,
            instrument_id: selectedId,
            instrument_name: selectedInstrument?.name || "",
          }
        : item
    );

    this.setState({ combinedData: updatedData });
  };

  handleReagentChange = (event, row) => {
    const selectedId = parseInt(event.target.value);
    const selectedReagent = (this.props.reagents || []).find(
      r => r.id === selectedId
    );

    const updatedData = this.state.combinedData.map(item =>
      item.analyte_id === row.analyte_id
        ? {
            ...item,
            reagent_id: selectedId,
            reagent_name: selectedReagent?.name || "",
          }
        : item
    );

    this.setState({ combinedData: updatedData });
  };

  handleResultTypeChange = (e, row) => {
    const newResultType = e.target.value;

    const updatedData = this.state.combinedData.map(item =>
      item.analyte_id === row.analyte_id
        ? { ...item, result_type: newResultType }
        : item
    );

    this.setState({ combinedData: updatedData });
  };

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  exportToExcel = () => {
    const { ResultList } = this.props;
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    // Define fields to export
    const fieldsToExport = [
      "id",
      "analyte",
      "units",
      "instrument",
      "method",
      "reagents",
      "result",
      "result_status",
      "result_type",
    ];

    // Map each row to an object with only the desired fields
    const dataToExport = ResultList.map(unit => ({
      id: unit.id,
      Analyte: unit.analyte,
      Unit: unit.units,
      Instrument: unit.instrument,
      Method: unit.method,
      Reagent: unit.reagents,
      Result_Type: unit.result_type,
      Result: unit.result,
      Result_Status: unit.result_status,
    }));

    // Convert data to Excel format and save as file
    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    const fileName = "Method_list" + fileExtension;
    saveAs(data, fileName);
  };

  render() {
    const approvedLabListColumns = this.getApprovedLabListColumns(); // Get the columns in render
    const id = this.props.match.params.id;
    const { SearchBar } = Search;
    const { combinedData, isDataLoaded } = this.state;
    const {
      schemeName,
      scheme_id,
      rounds,
      issue_date,
      closing_date,
      cycle_no,
      round_status,
    } = this.props;

    const { schemeType } = this.props;
    // ✅ use local schemeType instead of Redux

    const abrogateMode = this.isAbrogateMode(); // ✅ NEW

    const pageOptions = {
      sizePerPage: 50,
      totalSize: combinedData.length > 0 ? combinedData.length : " ",
      custom: true,
    };

    if (!isDataLoaded) {
      // return <div>Loading...</div>;
    }
    const defaultSorted = [
      {
        dataField: "id",
        order: "desc",
      },
    ];
    const { organization_name } = this.props.match.params;
    const participant_id = this.props.match.params.id1;
    return (
      <React.Fragment>
        {schemeType ? (
          <div className="page-content">
            <MetaTags>
              <title>Participant Result | NEQAS</title>
            </MetaTags>
            <Container fluid>
              {/* <Breadcrumbs title="Participant" breadcrumbItem="Unapproved" /> */}

              {/* ✅ NEW — heading shown only in abrogate mode */}
              {abrogateMode && (
                <>
                  <h4 className="text-danger text-center mb-3">
                    Abrogate Participant Results
                  </h4>
                  <div
                    className="alert alert-warning mx-auto"
                    style={{ maxWidth: "1000px" }}
                  >
                    <p className="fw-bold mb-1">What does Abrogate mean?</p>
                    <p className="mb-1">
                      Selecting <strong>Abrogate</strong> for an analyte marks
                      this participant&apos;s result for that analyte as
                      abrogated. In this participant&apos;s report, that analyte
                      will be shown as <strong>Abrogated</strong> instead of
                      being evaluated.
                    </p>
                    <ul className="mb-0 ps-3">
                      <li>
                        It applies only to the selected analyte of this
                        participant.
                      </li>
                      <li>
                        A reason is required, and the original result value is
                        kept.
                      </li>
                      <li>
                        Use <strong>Restore</strong> to reverse it and show the
                        result in the report again.
                      </li>
                    </ul>
                  </div>
                </>
              )}

              <Row className="mb-3 text-dark">
                <strong>
                  <Col className="d-flex flex-wrap justify-content-md-around justify-content-sm-start  p-3">
                    <div className="d-flex flex-column flex-md-row align-items-start  mb-2 mb-md-0 p-2">
                      <span className="me-2">Participant No:</span>
                      <span>
                        {
                          <span>
                            {this.state.labName || this.state.participantID}
                          </span>
                        }
                      </span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Scheme: </span>
                      <span>{schemeName}</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Cycle No: </span>
                      <span>{cycle_no}</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Round No: </span>
                      <span>{rounds}</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Issue Date:</span>
                      <span>
                        {moment(issue_date).format("DD-MMM-YY, h:mm A")}
                      </span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start p-2">
                      <span className="me-2">Closing Date: </span>
                      <span>
                        {moment(closing_date).format("DD-MMM-YY, h:mm A")}
                      </span>
                    </div>
                  </Col>
                </strong>
              </Row>
              <Row className="mb-4">
                <Col
                  xs={12}
                  className="d-flex flex-wrap gap-2 justify-content-center justify-content-md-start"
                >
                  <Button
                    onClick={this.exportToExcel}
                    className="btn btn-secondary"
                    style={{ minWidth: "140px" }}
                  >
                    Download Results
                  </Button>

                  {/* ✅ NEW — Submit hidden in abrogate mode */}
                  {!abrogateMode && (
                    <Button
                      type="button"
                      className="btn btn-success"
                      style={{ minWidth: "140px" }}
                      onClick={() => {
                        console.log("🟢 Submit button clicked!");
                        this.handleSubmit();
                      }}
                    >
                      Submit
                    </Button>
                  )}
                </Col>
              </Row>

              {/* 🔹 Table Section */}
              <Row className="justify-content-center">
                <Col xs={12} lg={10}>
                  <Card>
                    <CardBody>
                      {this.state.loading ? (
                        <div className="text-center py-5">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p className="mt-2 text-muted">
                            Fetching results, please wait...
                          </p>
                        </div>
                      ) : this.state.combinedData.length === 0 ? (
                        <div className="text-center py-5">
                          <h6 className="text-muted">No data available</h6>
                          <p className="small text-secondary">
                            Make sure analytes and results have been fetched
                            successfully.
                          </p>
                        </div>
                      ) : (
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField="analyte_id"
                          columns={this.getApprovedLabListColumns()}
                          data={this.state.combinedData}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <>
                              <div className="table-responsive">
                                <BootstrapTable
                                  id="printable-table"
                                  keyField="analyte_id"
                                  data={this.state.combinedData}
                                  columns={this.getApprovedLabListColumns()}
                                  ref={this.node}
                                  bordered={false}
                                  striped={false}
                                  hover
                                  defaultSorted={defaultSorted}
                                  classes="table table-bordered align-middle"
                                  // ✅ NEW — highlight abrogated rows
                                  rowClasses={row =>
                                    row.abrogated ? "table-danger" : ""
                                  }
                                  {...paginationTableProps}
                                />
                              </div>

                              <div className="d-flex justify-content-end mt-3">
                                <PaginationListStandalone
                                  {...paginationProps}
                                  onPageChange={this.onPaginationPageChange}
                                />
                              </div>
                            </>
                          )}
                        </PaginationProvider>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              {/* ✅ NEW — Pre-Analytical Assessment card, same format as the submission page.
                  Pre-filled from what's already saved for this participant (via combineData).
                  Hidden in abrogate mode. */}
              {!abrogateMode &&
                (Number(scheme_id) === 29 ||
                  Number(scheme_id) === 30 ||
                  Number(scheme_id) === 33 ||
                  Number(scheme_id) === 32 ||
                  Number(scheme_id) === 37) && (
                  <Row className="mt-4 justify-content-center">
                    <Col xs={12} lg={10}>
                      <Card>
                        <CardBody
                          style={{
                            backgroundColor: "#a6d4ff",
                            borderRadius: "6px",
                            padding: "15px",
                          }}
                        >
                          <Row className="mb-3">
                            <Col>
                              <div
                                style={{
                                  backgroundColor: "#f0f7ff",
                                  border: "1px solid #b8d4f0",
                                  borderLeft: "4px solid #2a7acc",
                                  borderRadius: "6px",
                                  padding: "14px 16px",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    color: "#1a5a99",
                                    marginBottom: "6px",
                                  }}
                                >
                                  Pre-Analytical Assessment (Optional):
                                </p>
                                <p
                                  style={{
                                    fontSize: "13px",
                                    color: "#313131",
                                    lineHeight: "1.6",
                                    marginBottom: "0",
                                  }}
                                >
                                  Participants are requested to record the
                                  observed condition of the EQA sample at the
                                  time of analysis. Pre-analytical verification
                                  is a critical component of the total testing
                                  process and plays a significant role in
                                  ensuring accurate and reliable results.
                                  Documenting the sample condition allows us to
                                  better interpret performance outcomes and
                                  understand any potential variables that may
                                  influence analytical results. Furthermore this
                                  is also an assessment of laboratory practices
                                  and staff competency in pre-analytical
                                  evaluation. It serves as a constructive
                                  measure to strengthen training, awareness, and
                                  adherence to good laboratory practices.
                                </p>
                              </div>
                            </Col>
                          </Row>

                          <Row className="align-items-center g-3">
                            {/* Sample Condition */}
                            <Col lg="5" className="d-flex align-items-center">
                              <span
                                className="me-2"
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Select:{" "}
                              </span>
                              <select
                                id="sample_condition"
                                className="form-select mt-0"
                                value={this.state.sample_condition}
                                onChange={e => {
                                  const newCondition = e.target.value;
                                  this.setState(prevState => {
                                    const updatedConditionRatings = {
                                      ...prevState.conditionRatings,
                                      [prevState.sample_condition]:
                                        prevState.rating,
                                    };
                                    return {
                                      sample_condition: newCondition,
                                      conditionRatings: updatedConditionRatings,
                                      rating:
                                        updatedConditionRatings[newCondition] ||
                                        null,
                                    };
                                  });
                                }}
                              >
                                <option value="">
                                  Select Sample Condition
                                </option>
                                <option value="Clear">Clear</option>
                                <option value="Clotted">Clotted</option>
                                <option value="Hemolyzed">Hemolyzed</option>
                                <option value="Icteric">Icteric</option>
                                <option value="Lipemic">Lipemic</option>
                              </select>
                            </Col>

                            {/* Rating only shown for Hemolyzed, Icteric, Lipemic */}
                            {["Hemolyzed", "Icteric", "Lipemic"].includes(
                              this.state.sample_condition
                            ) && (
                              <Col lg="5" className="d-flex align-items-center">
                                <span
                                  className="me-2"
                                  style={{
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Rating:
                                </span>
                                <div className="d-flex gap-1 align-items-end">
                                  {[1, 2, 3, 4, 5].map(bar => (
                                    <div
                                      key={bar}
                                      onClick={() =>
                                        this.setState(prevState => ({
                                          rating: bar,
                                          conditionRatings: {
                                            ...prevState.conditionRatings,
                                            [prevState.sample_condition]: bar,
                                          },
                                        }))
                                      }
                                      style={{
                                        width: "8px",
                                        height: `${bar * 5}px`,
                                        backgroundColor:
                                          bar <= (this.state.rating || 0)
                                            ? "#28a745"
                                            : "#ccc",
                                        cursor: "pointer",
                                        transition: "0.2s",
                                      }}
                                    />
                                  ))}
                                  {this.state.rating && (
                                    <span className="ms-2 fw-bold">
                                      {this.getBarStatus(this.state.rating)}
                                    </span>
                                  )}
                                  {this.state.rating && (
                                    <span className="ms-2 text-muted">
                                      ({this.state.rating}/5)
                                    </span>
                                  )}
                                </div>
                              </Col>
                            )}
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                )}

              {/* ✅ NEW — Abrogate / Restore modal */}
              <Modal
                isOpen={this.state.abrogateModal}
                toggle={this.closeAbrogateModal}
                centered
              >
                <ModalHeader toggle={this.closeAbrogateModal}>
                  {this.state.abrogateRow?.abrogated ? "Restore" : "Abrogate"}{" "}
                  Result – {this.state.abrogateRow?.analyte_name}
                </ModalHeader>
                <ModalBody>
                  {this.state.abrogateError && (
                    <div className="alert alert-danger">
                      {this.state.abrogateError}
                    </div>
                  )}
                  {this.state.abrogateRow?.abrogated ? (
                    <p>
                      This result was abrogated
                      {this.state.abrogateRow?.abrogation_reason
                        ? `: "${this.state.abrogateRow.abrogation_reason}"`
                        : "."}{" "}
                      Restore it so the participant&apos;s report shows this
                      result again?
                    </p>
                  ) : (
                    <>
                      <p className="mb-2">
                        Participant <strong>{this.state.labName}</strong> –
                        result value{" "}
                        <strong>{this.state.abrogateRow?.result}</strong>
                      </p>
                      <p className="text-muted small mb-2">
                        This analyte will be shown as Abrogated in this
                        participant&apos;s report.
                      </p>
                      <Label>Reason (required)</Label>
                      <Input
                        type="textarea"
                        rows="3"
                        value={this.state.abrogateReason}
                        onChange={e =>
                          this.setState({ abrogateReason: e.target.value })
                        }
                      />
                    </>
                  )}
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={this.closeAbrogateModal}>
                    Cancel
                  </Button>
                  <Button
                    color={
                      this.state.abrogateRow?.abrogated ? "success" : "danger"
                    }
                    disabled={this.state.abrogating}
                    onClick={this.submitAbrogate}
                  >
                    {this.state.abrogating
                      ? "Saving..."
                      : this.state.abrogateRow?.abrogated
                      ? "Restore"
                      : "Abrogate"}
                  </Button>
                </ModalFooter>
              </Modal>
            </Container>
          </div>
        ) : (
          <div>No scheme type available</div>
        )}
      </React.Fragment>
    );
  }
}
Results.propTypes = {
  match: PropTypes.object,
  schemeName: PropTypes.string,
  schemeType: PropTypes.string,
  cycle_no: PropTypes.string,
  history: PropTypes.object.isRequired,

  rounds: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  scheme_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  round_status: PropTypes.string,
  result_type: PropTypes.string,
  issue_date: PropTypes.string,
  closing_date: PropTypes.string,
  units: PropTypes.array,
  methods: PropTypes.array,
  reagents: PropTypes.array,
  instruments: PropTypes.array,

  AnalyteData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      units: PropTypes.array,
      methods: PropTypes.array,
      reagents: PropTypes.array,
      instruments: PropTypes.array,
    })
  ),

  PostResult: PropTypes.array,
  ResultList: PropTypes.array,

  className: PropTypes.any,
  onGetAnalytedata: PropTypes.func,
  onPostResult: PropTypes.func,
  onUpdateResult: PropTypes.func,
  roundStatus: PropTypes.object,
  // onGetResultsList: PropTypes.func,
  location: PropTypes.object,
};

const mapStateToProps = state => {
  if (!state) {
    console.error("Redux state is undefined!");
    return {};
  }
  console.log("Redux State:", state);

  return {
    AnalyteData: state.SchemeAnalytesList?.AnalyteData || [],

    schemeName: state.SchemeAnalytesList?.schemeName || "",
    schemeType: state.SchemeAnalytesList?.schemeType || "",
    rounds: state.SchemeAnalytesList?.rounds || "",
    scheme_id: state.SchemeAnalytesList?.scheme_id || null,
    round_status: state.SchemeAnalytesList?.round_status || "",
    result_type: state.SchemeAnalytesList?.result_type || "",
    issue_date: state.SchemeAnalytesList?.issue_date || "",
    closing_date: state.SchemeAnalytesList?.closing_date || "",
    cycle_no: state.SchemeAnalytesList?.cycle_no || "",

    // 🔹 Supporting lists
    units: state.SchemeAnalytesList?.units || [],
    methods: state.SchemeAnalytesList?.methods || [],
    instruments: state.SchemeAnalytesList?.instruments || [],
    reagents: state.SchemeAnalytesList?.reagents || [],
    ResultList: state.SchemeAnalytesList?.ResultList || [],
  };
};

const mapDispatchToProps = dispatch => ({
  onGetAnalytedata: id => dispatch(getAnalytesData(id)),
  onPostResult: (result, id) => dispatch(postResult(result, id)),
  onUpdateResult: (result, id, callback) =>
    dispatch(updateResult(result, id, callback)),
  // onGetResultsList: id => dispatch(getResultsList(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Results));
